import { useState, useEffect } from "react";
import FriendCard from "./FriendCard";
import WishlistDrawer from "./WishlistDrawer";
import Toast from "./Toast"; // 💬 import toast
import friendsData from "../data/friends.json";
import Navbar from "./Navbar";
import "../App.css";
import CheckoutModal from "./CheckoutModal";

export default function FriendMarketplace() {
  const [sortBy, setSortBy] = useState("rating");
  const [genderFilter, setGenderFilter] = useState("All");
  const [friends, setFriends] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistOpen, setWishlistOpen] = useState(false);

  // 💬 toast state
  const [toastMessage, setToastMessage] = useState("");
  const [toastVisible, setToastVisible] = useState(false);

  // load data
  useEffect(() => {
    const savedFriends = friendsData.map((friend) => {
      const saved = localStorage.getItem(`friend-${friend.id}`);
      if (saved) {
        const { upvotes, downvotes } = JSON.parse(saved);
        return { ...friend, upvotes, downvotes };
      }
      return { ...friend, upvotes: 0, downvotes: 0 };
    });
    setFriends(savedFriends);

    const savedWishlist = sessionStorage.getItem("wishlist");
    if (savedWishlist) setWishlist(JSON.parse(savedWishlist));
  }, []);

  const handleVote = (id, type) => {
    setFriends((prev) =>
      prev.map((f) => {
        if (f.id === id) {
          const newUp = type === "up" ? f.upvotes + 1 : f.upvotes;
          const newDown = type === "down" ? f.downvotes + 1 : f.downvotes;
          const updated = { ...f, upvotes: newUp, downvotes: newDown };
          localStorage.setItem(`friend-${id}`, JSON.stringify(updated));
          return updated;
        }
        return f;
      })
    );
  };

  // 💬 Toast helper
  const showToast = (msg) => {
    setToastMessage(msg);
    setToastVisible(true);
    setTimeout(() => setToastVisible(false), 2000);
  };

  const handleAddToWishlist = (friend) => {
    setWishlist((prev) => {
      const exists = prev.some((f) => f.id === friend.id);
      const updated = exists
        ? prev.filter((f) => f.id !== friend.id)
        : [...prev, friend];
      sessionStorage.setItem("wishlist", JSON.stringify(updated));

      // 💬 Trigger toast
      showToast(
        exists
          ? `❌ Removed ${friend.name} from Wishlist`
          : `✅ Added ${friend.name} to Wishlist`
      );

      return updated;
    });
  };

  const handleRemoveWishlist = (id) => {
    setWishlist((prev) => {
      const updated = prev.filter((f) => f.id !== id);
      sessionStorage.setItem("wishlist", JSON.stringify(updated));
      return updated;
    });
  };

  const friendsWithRating = friends.map((f) => {
    const up = f.upvotes || 0;
    const down = f.downvotes || 0;
    const dynamicRating =
      up + down === 0 ? f.rating || 0 : (5 * up) / (up + down);
    return { ...f, computedRating: parseFloat(dynamicRating.toFixed(1)) };
  });

  const filtered = friendsWithRating
    .filter((f) => genderFilter === "All" || f.gender === genderFilter)
    .sort((a, b) => {
      switch (sortBy) {
        case "rating":
          return b.computedRating - a.computedRating;
        case "height":
          return b.height - a.height;
        case "income":
          return b.income - a.income;
        case "name":
          return a.name.localeCompare(b.name);
        default:
          return 0;
      }
    });
    const [checkoutOpen, setCheckoutOpen] = useState(false);
  return (
    <>
<Navbar onToggleWishlist={() => setWishlistOpen(!wishlistOpen)} />   
<WishlistDrawer
  isOpen={wishlistOpen}
  wishlist={wishlist}
  onRemove={handleRemoveWishlist}
  onClose={() => setWishlistOpen(false)}
  onCheckout={() => {
    setCheckoutOpen(true);
    setWishlistOpen(false);
  }}
/>
<CheckoutModal
  open={checkoutOpen}
  wishlist={wishlist}
  onClose={() => setCheckoutOpen(false)}
/>
      <Toast message={toastMessage} show={toastVisible} /> {/* 💬 add toast */}

      <div className="app">
        <h1 className="title">🛒 Friend Marketplace</h1>

        <div className="controls">
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="rating">Sort by Rating</option>
            <option value="height">Sort by Height</option>
            <option value="income">Sort by Income</option>
            <option value="name">Sort by Name</option>
          </select>

          <select
            value={genderFilter}
            onChange={(e) => setGenderFilter(e.target.value)}
          >
            <option value="All">All Genders</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div className="friend-grid">
          {filtered.map((friend) => (
            <FriendCard
              key={friend.id}
              friend={friend}
              onVote={handleVote}
              onAddToWishlist={handleAddToWishlist}
            />
          ))}
        </div>
      </div>
    </>
  );
}
